import { render, staticRenderFns } from "./SalonsTableComponent.vue?vue&type=template&id=38064ef4&scoped=true&"
import script from "./SalonsTableComponent.vue?vue&type=script&lang=js&"
export * from "./SalonsTableComponent.vue?vue&type=script&lang=js&"
import style0 from "./SalonsTableComponent.vue?vue&type=style&index=0&id=38064ef4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38064ef4",
  null
  
)

export default component.exports